var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Component, Input, EventEmitter, Output } from '@angular/core';
import { CreateOrEditConfigurePermissionComponent } from './create-or-edit-configure-permission.component';
import * as _ from 'lodash';
import { ConfigureComponentBase } from '../../../../shared/configure-component-base';
import { ConfigurePermissionDto } from '../../../../shared/service-proxies/service-proxies';
var ConfigurePermissionListComponent = /** @class */ (function (_super) {
    __extends(ConfigurePermissionListComponent, _super);
    function ConfigurePermissionListComponent(injector, configPermissionServiceProxy, modalService) {
        var _this = _super.call(this, injector) || this;
        _this.configPermissionServiceProxy = configPermissionServiceProxy;
        _this.modalService = modalService;
        _this.active = false;
        _this.saving = false;
        _this.refreshPermissionList = new EventEmitter();
        return _this;
    }
    ConfigurePermissionListComponent.prototype.ngOnInit = function () {
        this.loadConfigurePermissions();
    };
    ConfigurePermissionListComponent.prototype.loadConfigurePermissions = function () {
        var _this = this;
        this.configPermissionServiceProxy.getConfigurePermissions(this.configureId).subscribe(function (result) {
            _this.allPermissions = result.items || [];
            _this.refreshPermissionList.emit(_this.allPermissions);
        });
    };
    ConfigurePermissionListComponent.prototype.addNewPermission = function () {
        var configurePermission = new ConfigurePermissionDto();
        configurePermission.configureId = this.configureId;
        this.showConfigurePermissionInfoPage(configurePermission);
    };
    ConfigurePermissionListComponent.prototype.editPermission = function (configurePermission) {
        this.showConfigurePermissionInfoPage(configurePermission);
    };
    ConfigurePermissionListComponent.prototype.deletePermission = function (item) {
        var _this = this;
        abp.ui.setBusy();
        this.configPermissionServiceProxy.checkConfigurePermissionUsed({
            configureId: item.configureId,
            tag: item.tag
        })
            .subscribe(function (isUsed) {
            if (isUsed) {
                _this.doDeletePermission(item.id, _this.lc('SureToDeleteUsedPermissionItem', item.name));
            }
            else {
                _this.doDeletePermission(item.id, _this.lc('SureToDeletePermissionItem', item.name));
            }
            abp.ui.clearBusy();
        }, function () { return abp.ui.clearBusy(); });
    };
    ConfigurePermissionListComponent.prototype.doDeletePermission = function (id, msg) {
        var _this = this;
        this.message.confirm(msg, function (isConfirmed) {
            if (isConfirmed) {
                _this.configPermissionServiceProxy.deletePermission(id).subscribe(function () {
                    _this.notify.info(_this.l('SuccessfullyDeleted'));
                    _.remove(_this.allPermissions, function (p) {
                        return p.id === id;
                    });
                });
            }
        });
    };
    ConfigurePermissionListComponent.prototype.showConfigurePermissionInfoPage = function (configurePermission) {
        var _this = this;
        var modalRef = this.modalService.show(CreateOrEditConfigurePermissionComponent, {
            initialState: {
                configurePermission: _.cloneDeep(configurePermission),
                active: true
            },
            backdrop: 'static', class: 'createOrEditConfigurePermissionModal'
        });
        var onClosedSub = modalRef.content.onClosed.subscribe(function (result) {
            if (result) {
                _this.loadConfigurePermissions();
            }
            onClosedSub.unsubscribe();
        });
    };
    __decorate([
        Input()
    ], ConfigurePermissionListComponent.prototype, "configureId", void 0);
    __decorate([
        Output()
    ], ConfigurePermissionListComponent.prototype, "refreshPermissionList", void 0);
    ConfigurePermissionListComponent = __decorate([
        Component({
            selector: 'configure-permission-list', template: "<div class=\"configure-permission-list\"> <form novalidate> <div class=\"fe-popup-middle\"> <div class=\"add-button\"> <button class=\"fe-btn fe-btn-default fe-btn-save\" (click)=\"addNewPermission()\">{{lc(\"AddConfigurePermissionItem\")}}</button> </div> <table class=\"table permission-list-table\"> <thead> <tr> <td>{{lc(\"SerialNumber\")}}</td> <td>{{lc(\"PermissionName\")}}</td> <td>{{lc(\"PermissionDescription\")}}</td> <td>{{l(\"Action\")}}</td> </tr> </thead> <tbody> <tr *ngFor=\"let item of allPermissions; let i = index\"> <td> {{i+1}} </td> <td> {{item.name}} </td> <td> <span [title]=\"item.description\"> {{(item.description||\"\").length>20 ? (item.description.substr(0,20)+\"...\"):item.description }} </span> </td> <td> <a href=\"javascript:void(0)\" (click)=\"editPermission(item)\">{{l(\"Edit\")}}</a> <a href=\"javascript:void(0)\" (click)=\"deletePermission(item)\">{{l(\"Delete\")}}</a> </td> </tr> </tbody> </table> </div> </form> </div> ",
            styles: [".configure-permission-list { .permission-list-table { line-height: 29px; margin-bottom: 0; } .permission-list-table th, .permission-list-table td { padding: 0; } .permission-list-table thead tr { background: #f0f1f5; } .permission-list-table { thead tr, tbody tr { display: table; width: 100%; table-layout: fixed; } tbody { display: block; max-height: 304px; overflow: auto; } td:nth-child(1) { width: 15%; } td:nth-child(2) { width: 35%; } td:nth-child(3) { width: 35%; } td:nth-child(4) { widows: 15%; } a { padding-right: 6px; text-decoration: none; color: #3695ff; } } .add-button { margin-bottom: 10px; button { width: 90px; } } } "]
        })
    ], ConfigurePermissionListComponent);
    return ConfigurePermissionListComponent;
}(ConfigureComponentBase));
export { ConfigurePermissionListComponent };
